exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1d8ab{margin:0 auto;max-width:680px;text-align:center}._1d8ab+._1d8ab{margin-top:32px;margin-top:2rem}@media screen and (min-width:768px){._1d8ab+._1d8ab{margin-top:3rem}}._1ujzh{margin-bottom:16px;margin-bottom:1rem;width:140px;height:140px;display:inline-block;position:relative;background-color:#6eb658;border-radius:140px}._1ujzh img{position:absolute;z-index:1;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._2ONhS{margin-top:16px;margin-top:1rem}", ""]);

// exports
exports.locals = {
	"root": "_1d8ab",
	"svg": "_1ujzh",
	"foot": "_2ONhS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Teaser/Section/Section.css
// module id = 687
// module chunks = 2